import { AxiosInstanceCDS } from "../constant/httpsHandler";
import AppConstants from "../constant";

export async function userDailyTime(username) {
  return await AxiosInstanceCDS.get(
    `${AppConstants.serverConstants.API_ENDPOINTS.USER_HEADER_DETAILS}?source=test&perpage=1&next=1&username=${username}`
  );
}
